// see launchFromURI(const char* runString) at around line 2500 in main.cpp in the EMP repository for most up-to-date information.
import fetchSQS from "./fetchSQS";

// possible opts: "attachment", "interned", "goto", "ent", "img", "vis", "usr", "props", "task", "historyObj", "history", "automation", "launch"
export default function launchSourceOne(opt, UUIDList) {
   let payload = "";
   if (UUIDList) {
      //format a list of UUIDs into an acceptable string for server parsing
      UUIDList.forEach((UUID, i) => {
         if (i < UUIDList.length - 1) {
            payload += "{" + UUID + "}" + "|";
         } else {
            payload += "{" + UUID + "}";
         }
      });
   }
   //send request to server, which will return a compressed url.  Use window.open to launch source one.
   fetchSQS("launcher", "POST", {
      opt: opt ? opt : "login", // "login" isn't really an opt, but we login with any string that is not empty
      payload: UUIDList ? payload : "", // A misconfigured payload will still login... not sure if desired
   }).then((res) => {
      if (res.success) {
         let address = `sourceone://${res.uri}`;
         window.open(address);
      } else {
         console.error("Django Server Error");
      }
   });
}
